import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';

import Badge from 'react-bootstrap/Badge';

import classes from './Relation.css';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

class Relation extends React.Component{

    handleQuestion = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                    <div className={classes.Question}>
                    <Container>
                        <Row>
                            <Col>
                            <h3>What is it?</h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <p>Relation manager is the system that automatically connects you and your friends at a set schedule. </p>
                            <p>You can manage your friends here.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button variant="outline-info" onClick={onClose} block>I see</Button>
                            </Col>
                        </Row>
                    </Container>
                    </div>

                </div>
              );
            }
          });

    }

    render(){

        return (
            <Container>
            <Card bsPrefix={classes.CardBody}>
            <Card.Header><b>Relation Manager</b> <span className={classes.QuestionMark} onClick={this.handleQuestion} ><FontAwesomeIcon icon={faQuestionCircle} / > <Badge variant="warning">new</Badge></span></Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <div>
                            <Link to={'/relation/friends'}>
                            <b className={classes.BadgeText}>{this.props.friend_count}</b> 
                            <div>
                            <Badge variant="info">Friends</Badge> 
                            <Badge variant="warning">click me!</Badge>
                            </div>
                            </Link>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <Link to={'/relation/appointments'}>
                            <b className={classes.BadgeText}>{this.props.appointment_count}</b> 
                            <div>
                            <Badge variant="info">Appointments</Badge> 
                            <Badge variant="warning">click me!</Badge>
                            </div>
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
            </Card>
          </Container>
        );
    }
}

// export default Appointment;
const mapStateToProps = state => {
    return {
        friends: state.relation.friends,
        guests: state.relation.friends,
        friend_count: state.relation.friend_count,
        appointment_count: state.relation.appointment_count,
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Relation);


// WEBPACK FOOTER //
// ./src/containers/Profile/Relation/Relation.js